/* eslint-disable react/destructuring-assignment */
import fullTitle from 'react-xocs/dist/xocs/references/full-title';
import titleOverride from './title';
import authors from './authors';

/**
* Renders contribution with a limited scope override to wrap `title` tags in links,
* but not `title` tags for journals
*/
export default function contribution(context, content, key) {
  if (!content.$$) {
    return null;
  }

  const children = [];

  const authorsTag = content.$$.find(e => e['#name'] === 'authors');
  const titleTag = content.$$.find(e => e['#name'] === 'title');
  const translatedTitleTag = content.$$.find(e => e['#name'] === 'translated-title');

  // limited scope override
  const oldTitleOverride = context.overrides.title;
  context.overrides.title = titleOverride;
  const title = fullTitle(context, titleTag, translatedTitleTag);
  context.overrides.title = oldTitleOverride;

  // Display title first
  if (title && title.length) {
    children.push(
      <div className="reference-panel-title text-l u-font-serif u-margin-s-bottom" key={0}>
        {title}
      </div>,
    );
  }

  if (authorsTag) {
    children.push(
      authors(context, authorsTag, children.length),
    );
  }

  const lang = content.$ && content.$.lang;
  return (
    <div
      className="contribution"
      key={key}
      lang={lang}
    >
      {children}
    </div>
  );
}
